// Selecting
const $8582df9cef07b7e0$var$microCreateElFunc = (arg, ...classes)=>{
    const element = document.createElement(arg[0]);
    element.textContent = arg[1];
    element.classList.add(...classes);
    return element;
};
var $8582df9cef07b7e0$export$2e2bcd8739ae039 // arg[0] => element tag
 // arg[1] => elements textContent
 // ...classes => add class names
 = $8582df9cef07b7e0$var$microCreateElFunc;


const $6e9c4d482135a4fe$export$5756cd37128ff46e = (txt, dest)=>{
    const arrOfColors2 = [
        "#475569",
        "#ea580c",
        "#0891b2",
        "#1d4ed8",
        "#4a044e",
        "#78350f",
        "#6b7280",
        "#1a2e05"
    ];
    let x = Math.floor(Math.random() * 6); // Variations in colored Text
    txt.split("").forEach((item, i, arr)=>{
        if (x >= arrOfColors2.length) x = 0;
        const span = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
            "span",
            arr[i]
        ]);
        span.style.color = arrOfColors2[x];
        x++;
        dest.append(span);
    });
};


// warning create function
const $86f4a09882fb9fd3$export$f53c7b1a8269886 = (_err, _body)=>{
    //create Element
    const warning = document.createElement("p");
    const warningBackground = document.createElement("div"); // create background for blur-fx.
    warningBackground.classList.add("warning-background"); // styling.
    warning.textContent = _err.message;
    _body.prepend(warningBackground); // put warning as firstChild of body.
    warningBackground.append(warning);
    //short intervall for loading...
    setTimeout(()=>{
        warning.classList.add("warning", "warning-animation-1", "fs-xl", "flex-row-center");
        warningBackground.classList.add("zz");
    }, 10);
    // shows the warning for 5 sec. than resolves and dissappears
    const ff = ()=>{
        return new Promise((res)=>{
            setTimeout(()=>{
                res("warning-timeout resolved...");
            }, 5000);
        });
    };
    ff().then(()=>{
        warning.classList.remove("warning-animation-1"); // so the warning animation fires everytime
        warningBackground.remove();
    });
    // remove warning when clicked out of the green box.
    warningBackground.addEventListener("click", ()=>{
        warning.classList.remove("warning-animation-1"); // so the warning animation fires everytime
        warningBackground.remove(); // remove card => back to start
    });
};






const $ad537ead75233e76$var$cardHeadingFunc = (heading, data, ...classes)=>{
    const el = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        heading
    ], ...classes);
    (0, $6e9c4d482135a4fe$export$5756cd37128ff46e)(data, el);
    return el;
};
var $ad537ead75233e76$export$2e2bcd8739ae039 = $ad537ead75233e76$var$cardHeadingFunc;


// Image Border-Color Function
/* chooses a random color for the ourline of the displayed image in the
   card // used in createCard function. */ const $f44330367107662e$var$imageBorderColor = ()=>{
    const colorArr = [
        "#99f6e4",
        "#155e75",
        "#6366f1",
        "#e879f9",
        "#881337",
        "#fbbf24"
    ];
    //Math.floor(Math.random() * (max - min + 1) + min);  // standard random function
    return colorArr[Math.floor(Math.random() * 6)];
};
var $f44330367107662e$export$2e2bcd8739ae039 = $f44330367107662e$var$imageBorderColor;



const $7b46e18514b9d85c$var$createLocation = (data, ...classes)=>{
    if (data) {
        const xx = (0, $ad537ead75233e76$export$2e2bcd8739ae039)("h3", data, ...classes);
        return xx;
    }
    return "_no location given_";
};
var $7b46e18514b9d85c$export$2e2bcd8739ae039 = $7b46e18514b9d85c$var$createLocation;



// create link function.
const $0b30ee1fa3f21300$var$createLink = (dataHtmlUrl, ...classes)=>{
    const linkDiv = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "div"
    ], "w-100", "flex-row-center", "border-bottom");
    const link = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "a",
        "gh-page"
    ], "gh-link", "margin-block-big", "flex-row-center");
    link.href = dataHtmlUrl;
    linkDiv.append(link);
    return linkDiv;
};
var $0b30ee1fa3f21300$export$2e2bcd8739ae039 = $0b30ee1fa3f21300$var$createLink;


const $ad47ec6ff39957c3$var$collapseFunc = (ev)=>{
    const hideContent = ev.target.nextElementSibling;
    if (hideContent.style.maxHeight) hideContent.style.maxHeight = null;
    else {
        if (ev.target.innerText === "Bio") hideContent.style.maxHeight = hideContent.scrollHeight + "px";
        if (ev.target.innerText === "Followers") {
            hideContent.style.maxHeight = "500px";
            hideContent.style.overflowY = "auto";
        }
    }
};
var $ad47ec6ff39957c3$export$2e2bcd8739ae039 = $ad47ec6ff39957c3$var$collapseFunc;



const $94f1d06e2cc3131b$var$createBio = (data, txt, ...classes)=>{
    const bioDiv = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "div"
    ], classes[0], "w-100");
    const contentDiv = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "div"
    ], classes[1]);
    const collapseBtn = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "button",
        txt
    ], "cursor", "fs-m", "border-bottom", "collapse-btn", "w-100");
    const bioText = data ? data : "User has no biography";
    const bio = `<p class="bio-dark-text">${bioText}</p>`;
    contentDiv.insertAdjacentHTML("beforeend", bio);
    bioDiv.append(collapseBtn, contentDiv);
    collapseBtn.addEventListener("click", (0, $ad47ec6ff39957c3$export$2e2bcd8739ae039));
    return bioDiv;
};
var $94f1d06e2cc3131b$export$2e2bcd8739ae039 = $94f1d06e2cc3131b$var$createBio;






const $c37554aaede5b7d5$var$createFollowers = (_data, _cardContainer)=>{
    const followersWrapper = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "div"
    ], "followers-wrapper", "shadow3");
    // CollapseButton
    const collapseBtn = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "button",
        "Followers"
    ], "collapse-btn", "cursor", "fs-m", "border-bottom");
    // Followers Div
    const followersDiv = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "div"
    ], "followers-div");
    followersWrapper.append(collapseBtn, followersDiv);
    if (!_data.followers) {
        console.log("User has no followers");
        const noFollowersPar = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
            "p",
            "User has no Followers or the profile is private."
        ]);
        followersDiv.classList.add("bio-content");
        followersDiv.append(noFollowersPar);
        collapseBtn.addEventListener("click", (0, $ad47ec6ff39957c3$export$2e2bcd8739ae039));
        return followersWrapper;
    } else {
        fetch(_data.followers_url).then((resp)=>resp.json()).then((x_data)=>{
            x_data.forEach((e)=>{
                const follower = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
                    "div"
                ], "follower", "border-radius", "flex-col-center");
                follower.dataQ = e.login; // so you can click on the li background and still show new follower.
                // Image
                const followerImg = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
                    "img"
                ], "follower-img", "cursor", "round");
                followerImg.src = e.avatar_url;
                followerImg.alt = e.login;
                followerImg.style.outlineColor = (0, $f44330367107662e$export$2e2bcd8739ae039)();
                // name
                const followerName = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
                    "p"
                ], "follower-name", "margin-block-medium");
                followerName.setAttribute("alt", e.login);
                (0, $6e9c4d482135a4fe$export$5756cd37128ff46e)(e.login, followerName); // show letters in different colors
                // Appending
                follower.append(followerImg, followerName);
                followersDiv.append(follower);
                //autoScroll to new user
                _cardContainer.lastElementChild.scrollIntoView({
                    behavior: "smooth"
                });
            });
            return followersWrapper;
        }).catch((err)=>console.log(err));
        collapseBtn.addEventListener("click", (0, $ad47ec6ff39957c3$export$2e2bcd8739ae039));
        return followersWrapper;
    }
};
var $c37554aaede5b7d5$export$2e2bcd8739ae039 = $c37554aaede5b7d5$var$createFollowers;



//------------------------------------------------------------------------------------
// Create Card Function
let $b3b5eaa82d629820$var$colorCounter = 1;
const $b3b5eaa82d629820$export$b7316deff43c35f7 = (_data, _cardContainer)=>{
    // Card
    const card = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "div"
    ], "gh-card", "divider", `bg${$b3b5eaa82d629820$var$colorCounter}`, "flex-col-center", "margin-block-big");
    //------------------------------------------------------------------------------------
    $b3b5eaa82d629820$var$colorCounter++;
    if ($b3b5eaa82d629820$var$colorCounter > 6) $b3b5eaa82d629820$var$colorCounter = 1;
    //------------------------------------------------------------------------------------
    // name
    const ghName = (0, $ad537ead75233e76$export$2e2bcd8739ae039)("h3", _data.name, "fs-xl", "margin-block-medium", "margin-inline-medium");
    // close button for card
    const closeBtn = document.createElement("span");
    closeBtn.classList.add("fa-regular", "fa-circle-xmark", "card-close-btn", "cursor", "fs-xl", "margin-inline-small");
    //show Image
    const ghImage = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
        "img"
    ], "gh-image", "round");
    ghImage.src = _data.avatar_url;
    ghImage.style.borderColor = (0, $f44330367107662e$export$2e2bcd8739ae039)();
    // location
    const ghLocation = (0, $7b46e18514b9d85c$export$2e2bcd8739ae039)(_data.location, "fs-xl", "margin-block-medium");
    // link to GH-page.
    const ghLink = (0, $0b30ee1fa3f21300$export$2e2bcd8739ae039)(_data.html_url, "gh-link-image", "shadow1", "round", "margin-block-medium");
    const ghBio = (0, $94f1d06e2cc3131b$export$2e2bcd8739ae039)(_data.bio, "Bio", "show-div", "bio-content");
    // follwers
    const ghFollowers = (0, $c37554aaede5b7d5$export$2e2bcd8739ae039)(_data, _cardContainer);
    // appending
    // ghName.append(closeBtn);
    card.append(ghName, ghImage, ghLocation, ghLink, ghBio, ghFollowers, closeBtn);
    _cardContainer.append(card);
    //------------------------------------------------------------------------------------
    //showFollower in new card.
    ghFollowers.lastElementChild.addEventListener("click", (ee)=>{
        if (ee.target.alt === undefined) return;
        else (0, $77ac944da51b7354$export$d87cf90f83950ef6)((0, $77ac944da51b7354$export$bbca72f41c6a0341), ee.target.alt).then((data)=>{
            $b3b5eaa82d629820$export$b7316deff43c35f7(data, (0, $77ac944da51b7354$export$6b2d426110a11d7a));
        });
    });
    //------------------------------------------------------------------------------------
    // card close Button Click-Event
    closeBtn.addEventListener("click", ()=>{
        card.remove();
        console.clear();
    });
};



const $77ac944da51b7354$var$container = document.getElementById("container");
const $77ac944da51b7354$var$searchInput = document.querySelector("input");
const $77ac944da51b7354$var$searchBtn = document.querySelector("button");
const $77ac944da51b7354$export$6b2d426110a11d7a = document.getElementById("card-container");
const $77ac944da51b7354$var$body = document.querySelector("body");
const $77ac944da51b7354$var$toTop = document.getElementById("to-top");
//------------------------------------------------------------------------------------
const $77ac944da51b7354$var$scrollFunction = ()=>{
    let curr = window.scrollY;
    if (curr > 1000) $77ac944da51b7354$var$toTop.className = "to-top-btn border-radius show-btn";
    else $77ac944da51b7354$var$toTop.className = "to-top-btn hide-btn";
};
const $77ac944da51b7354$var$mainHeading = (0, $8582df9cef07b7e0$export$2e2bcd8739ae039)([
    "h1"
], "fs-mega", "flex-row-center");
$77ac944da51b7354$var$mainHeading.id = "top";
$77ac944da51b7354$var$body.prepend($77ac944da51b7354$var$mainHeading);
//heading Text
const $77ac944da51b7354$var$h1Txt = "Github Profile Viewer";
//------------------------------------------------------------------------------------
// create H1 heading in colors
(0, $6e9c4d482135a4fe$export$5756cd37128ff46e)($77ac944da51b7354$var$h1Txt, $77ac944da51b7354$var$mainHeading);
//------------------------------------------------------------------------------------
// Container
$77ac944da51b7354$var$container.classList.add("search-container", "flex-row-center");
// Input
$77ac944da51b7354$var$searchInput.classList.add("input", "shadow1", "border-radius", "fs-m");
$77ac944da51b7354$var$searchBtn.classList.add("btn", "cursor");
// Button
$77ac944da51b7354$var$searchBtn.classList.add("search-button", "shadow1", "border-radius");
// Url
const $77ac944da51b7354$export$bbca72f41c6a0341 = "https://api.github.com/users/";
//------------------------------------------------------------------------------------
// Main Function
const $77ac944da51b7354$export$d87cf90f83950ef6 = async (_url, userName = $77ac944da51b7354$var$searchInput.value)=>{
    try {
        const res = await fetch(_url + userName);
        const data = await res.json();
        if (!userName) throw new Error("Invalid Input");
        if (!data.name) throw new Error("No User with that name");
        if (data.message === "Not Found") throw new Error("Name not found...");
        if (res.status >= 400) throw new Error("something is W");
        console.log(data); // logging the response data
        userName = ""; // deletes text in input after search.
        return data;
    } catch (err) {
        (0, $86f4a09882fb9fd3$export$f53c7b1a8269886)(err, $77ac944da51b7354$var$body);
    }
};
//------------------------------------------------------------------------------------
// EventListener for Go.. Button
$77ac944da51b7354$var$searchBtn.addEventListener("click", ()=>{
    $77ac944da51b7354$export$d87cf90f83950ef6($77ac944da51b7354$export$bbca72f41c6a0341).then((data)=>{
        (0, $b3b5eaa82d629820$export$b7316deff43c35f7)(data, $77ac944da51b7354$export$6b2d426110a11d7a);
    }).then(()=>{
        // Auto Scroll to user
        $77ac944da51b7354$export$6b2d426110a11d7a.lastElementChild.scrollIntoView({
            behavior: "smooth"
        });
    });
});
//EventListener totopButton Hide / Show
window.addEventListener("scroll", $77ac944da51b7354$var$scrollFunction);
// Auto Scroll to Top when clicked
$77ac944da51b7354$var$toTop.addEventListener("click", (ee)=>{
    $77ac944da51b7354$var$body.scrollIntoView({
        behavior: "smooth"
    });
});


//# sourceMappingURL=index.8592b7ea.js.map
